import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScriptService } from 'ngx-script-loader';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class StreetViewService {

  // @ts-ignore
  private svService: google.maps.StreetViewService;

  constructor(
    private http: HttpClient,
    private config: AppConfig,
    private scriptService: ScriptService,
  ) {
    this.http.get(this.config.getEndpoint('gsv/api_key')).pipe(
      mergeMap(data => this.scriptService.loadScript(`https://maps.googleapis.com/maps/api/js?key=${ data['text'] }`)),
      // mergeMap(() => this.scriptService.loadScript('https://unpkg.com/leaflet.gridlayer.googlemutant@latest/Leaflet.GoogleMutant.js'))

    ).subscribe(_ => {
        // @ts-ignore
        this.svService = new google.maps.StreetViewService();
      });
  }

  // @ts-ignore
  generatePanoramaObject(location): Promise<google.maps.StreetViewPanoramaData> {
    // @ts-ignore
    return new Promise<google.maps.StreetViewPanoramaData>((resolve, reject) => {
      this.svService.getPanorama({ location }, (result, status) => {
        if (status === 'OK') {
          resolve(result);
        } else {
          reject(status);
        }
      });
    });
  }

  getPanoUrl(location, pano, zoom = 1, heading = 0, pitch = 0, size = '400x400') {
    const params: HttpParams = new HttpParams().append(
      'street_view_args', this.buildStreetViewArgs(location, pano, zoom, heading, pitch, size));

    return this.http.get(this.config.getEndpoint('gsv/signed_url'), { params })
      .pipe(map(data => {
        // tslint:disable-next-line
        return data['text'];
      }));
  }

  postImage(location, pano, heading = 0, pitch = 0, zoom = 1, size = '400x400'): Observable<number> {
    const params = new HttpParams()
      .append('streetview_args', `?${ this.buildStreetViewArgs(location, pano, zoom, heading, pitch, size) }`);

    return this.http.post<number>(this.config.getEndpoint('image/create_streetview_image'), null, { params })
      .pipe(map(data => data['id']));
  }

  private buildStreetViewArgs(location, pano, zoom = 1, heading = 0, pitch = 0, size = '400x400') {
    let args = `location=${ location.lat },${ location.lng }&pano=${ pano }&zoom=${ zoom }&heading=${ heading }`
      + `&pitch=${ pitch }`;

    if (size != null) {
      args += `&size=${ size }`;
    }
    return args;
  }

}
